import React, { useEffect, useRef, useState } from 'react'
import useTranslation from 'hooks/useTranslation'
import Button from 'components/Button'
import Post from 'components/Post'
import './index.scss'

interface TabsProps {
  body: board.BoardResponse | null | undefined
  activeTab: string
  post: book.BookEntry[]
  postHasMore: boolean
  loadMorePosts: () => void
  setModal: (modal: string) => void
  setInitialSlide: (idx: number) => void
  setActiveTab: (tab: string) => void
  unlockAccess: (password: string) => void
}

const tabs = ['biography', 'photos', 'video', 'book']

const Tabs: React.FC<TabsProps> = ({ body, activeTab, post, postHasMore, loadMorePosts, setModal, setInitialSlide, setActiveTab, unlockAccess }) => {
  const { t } = useTranslation('profile')

  const [password, setPassword] = useState('')
  const password_protected = body?.data.password_protected && !body?.data.password_valid
  const updatedTabs = body?.data.is_obituary
    ? ['nekrolog', ...tabs]
    : tabs;

  const startX = useRef(0)
  const startY = useRef(0)
  const isHorizontalSwipe = useRef(false)
  const containerRef = useRef<HTMLDivElement>(null)

  const handleTabClick = (tab: string) => {
    setActiveTab(tab)
  }

  const handleTouchStart = (e: TouchEvent) => {
    startX.current = e.touches[0].clientX
    startY.current = e.touches[0].clientY
    isHorizontalSwipe.current = false
  }

  const handleTouchMove = (e: TouchEvent) => {
    const deltaX = e.touches[0].clientX - startX.current
    const deltaY = e.touches[0].clientY - startY.current

    if (Math.abs(deltaX) > Math.abs(deltaY)) {
      isHorizontalSwipe.current = true
      e.preventDefault()
    }
  }

  const handleTouchEnd = (e: TouchEvent) => {
    if (!isHorizontalSwipe.current) {
      return
    }

    const endX = e.changedTouches[0].clientX
    const deltaX = endX - startX.current

    if (deltaX < -50) {
      const currentIndex = updatedTabs.indexOf(activeTab)
      if (currentIndex < updatedTabs.length - 1) {
        handleTabClick(updatedTabs[currentIndex + 1])
      }
    } else if (deltaX > 50) {
      const currentIndex = updatedTabs.indexOf(activeTab)
      if (currentIndex > 0) {
        handleTabClick(updatedTabs[currentIndex - 1])
      }
    }
  }

  useEffect(() => {
    const tabContents = document.querySelectorAll('.tab-content')
    let maxHeight = 0

    tabContents.forEach(tabContent => {
      const height = (tabContent as HTMLElement).clientHeight
      if (height > maxHeight) {
        maxHeight = height
      }
    })

    const profileTabsBody = document.querySelector('.profile__tabs__body') as HTMLElement
    if (profileTabsBody) {
      profileTabsBody.style.minHeight = `${maxHeight}px`
    }

    if (body?.data.isEmptyBiography) {
      console.log('jesteeem')
      setActiveTab('book')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    const container = containerRef.current
    container?.addEventListener('touchstart', handleTouchStart)
    container?.addEventListener('touchmove', handleTouchMove, { passive: false })
    container?.addEventListener('touchend', handleTouchEnd)

    return () => {
      container?.removeEventListener('touchstart', handleTouchStart)
      container?.removeEventListener('touchmove', handleTouchMove)
      container?.removeEventListener('touchend', handleTouchEnd)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab])
  return (
    <>
      <div className="profile__tabs profile__tabs--profile">
        <div className="profile__tabs__head">
          <div className="wrap">
            {updatedTabs.map(tab => (
              <span
                key={tab}
                className={activeTab === tab ? 'active' : ''}
                onClick={() => handleTabClick(tab)}
              >
                {body?.data.is_obituary && tab === 'nekrolog' && t('obituary')}
                {tab === 'biography' && t('biography')}
                {tab === 'photos' && t('photos')}
                {tab === 'video' && t('videos')}
                {tab === 'book' && t('book')}
              </span>
            ))}
          </div>
        </div>

        <div className="profile__tabs__body" ref={containerRef}>
          {updatedTabs.map((tab, index) => {
            const activeIndex = updatedTabs.indexOf(activeTab)
            let slideClass = ''
            if (index < activeIndex) {
              slideClass = 'slide-in-left'
            } else if (index > activeIndex) {
              slideClass = 'slide-in-right'
            }

            if (password_protected) return (
              <div
                key={tab}
                className={`tab-content ${activeTab === tab ? 'active' : ''} ${slideClass}`}>
                <div className='profile__tabs__password'>
                  <p>{t('password_protected_access')}</p>
                  <div className='myInput'>
                    <label>{t('password')}</label>
                    <div className='profile__tabs__password__group'>
                      <input
                        value={password}
                        placeholder={t('enter_password')}
                        onChange={e => {
                          setPassword(e.target.value)
                        }} />
                      <i
                        className='icon icon--arrow-right'
                        onClick={() => {
                          unlockAccess(password)
                        }} />
                    </div>
                  </div>
                </div>
              </div>
            )

            return (
              <div
                key={tab}
                className={`tab-content ${tab} ${activeTab === tab ? 'active' : ''} ${slideClass}`}
              >
                {body?.data.is_obituary && body.data.obituary && tab === 'nekrolog' && (
                  <div className="obituary">
                    <div className="obituary__text" dangerouslySetInnerHTML={{ __html: body?.data.obituary.text }}></div>
                    {body?.data.obituary.steps.body_exposure && <div className="obituary__item">
                      <h2>Wystawienie ciała</h2>
                      <div className="addObiutary__ceremony">
                        <div className="addObituary__ceremony__row">
                          {body?.data.obituary.steps.body_exposure.place}
                        </div>
                        <div className="addObituary__ceremony__row">

                        </div>
                        <div className="addObituary__ceremony__row">

                        </div>
                      </div>
                    </div>}
                  </div>
                )}
                {tab === 'biography' && (<>
                  {body?.data?.biography
                    ? <div
                      className='biographyHtml'
                      dangerouslySetInnerHTML={{ __html: body.data.biography }} />
                    : <div />}
                </>
                )}
                {tab === 'photos' && (
                  <div className='photosWrap'>
                    {body?.data && body.data?.gallery.length > 0 && body.data.gallery.some(item => item.isImage && item.isPublished)
                      ? <>
                        {body.data.gallery
                          .filter(photo => photo.isPublished && photo.isImage)
                          .map((photo, index) => (
                            <img
                              key={index}
                              src={photo.thumbnailUrl}
                              alt={photo.displayName}
                              onClick={() => {
                                setModal('gallery')
                                setInitialSlide(index)
                              }
                              } />
                          ))}
                        <div onClick={() => setModal('addphotos')}><i className="icon icon--add-photo s32"></i> <span>{t('send_materials_to_the_family')}</span></div>
                      </>
                      : <p onClick={() => setModal('addphotos')} style={{ textAlign: 'center' }}>{t('no_photos')},<br></br> {t('click_to_send_photos_to_the_family')}</p>}
                  </div>
                )}
                {tab === 'video' && (
                  <div className='photosWrap'>
                    {body?.data && body.data?.gallery.length > 0 && body.data.gallery.some(item => item.isVideo && item.isPublished)
                      ? <>
                        {body.data.gallery
                          .filter(photo => photo.isPublished && photo.isVideo)
                          .map((photo, index) => (
                            <div className='photoWrap'
                              onClick={() => {
                                setModal('galleryVideo')
                                setInitialSlide(index)
                              }
                              }>
                              <img
                                key={index}
                                src={photo.thumbnailUrl}
                                alt={photo.displayName}
                              />
                              {photo.isVideo && <i className='icon s24 icon--movie'></i>}
                            </div>
                          ))}
                        <div onClick={() => setModal('addphotos')}><i className="icon icon--add-photo s32"></i><span>{t('send_materials_to_the_family')}</span></div>
                      </>
                      : <p onClick={() => setModal('addphotos')} style={{ textAlign: 'center' }}>{t('no_videos')},<br></br> {t('click_to_send_videos_to_the_family')}</p>}
                  </div>
                )}
                {/* {tab === 'book' && (
                  <div className='booksWrap'>
                    {body?.data && body.data?.book.length > 0
                      ? <>{body.data.book.map(post => (
                        post.isPublished && <Post
                          key={post.id}
                          name={post.signature}
                          desc={post.text}
                          date={post.date}
                        />
                      ))}
                        <Button type='empty' action={() => setModal('post')} text={t('add_an_entry')} />
                      </>
                      : <p className='empty' onClick={() => setModal('post')}>{t('no_entries_in_the_guestbook_click_to_add')}</p>
                    }
                  </div>
                )} */}

                {tab === 'book' && (
                  <div className='booksWrap'>
                    {post && post.length > 0
                      ? <>{post.map(post => (<Post
                        key={post.id}
                        name={post.signature}
                        desc={post.text}
                        date={post.date}
                      />
                      ))}
                        {postHasMore
                          ? <button className="btn btn--empty" onClick={loadMorePosts}>{t('load_more')}</button>
                          : <Button type='empty' action={() => setModal('post')} text={t('add_an_entry')} />}
                      </>
                      : <p className='empty' onClick={() => setModal('post')}>{t('no_entries_in_the_guestbook_click_to_add')}</p>}
                  </div>
                )}

              </div>
            )
          })}
        </div>
      </div>
    </>)
}

export default Tabs